import Stakeholders from "./Stakeholders.container";
export default Stakeholders;